import { TAppState } from '../../types/appState';

export function masterFiltersSelector(state: TAppState) {
  return state.masterFilters;
}
